export default function SkeletonCard() {
  return (
    <div style={{
      background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.06)",
      borderRadius:12, padding:"13px 14px", marginBottom:8,
    }}>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -400px 0; }
          100% { background-position: 400px 0; }
        }
        .skel {
          background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
          background-size: 400px 100%;
          animation: shimmer 1.4s ease infinite;
          border-radius: 6px;
        }
      `}</style>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
        <div>
          <div className="skel" style={{ width:60, height:14, marginBottom:6 }}/>
          <div className="skel" style={{ width:120, height:10, marginBottom:4 }}/>
          <div className="skel" style={{ width:80, height:9 }}/>
        </div>
        <div style={{ textAlign:"right" }}>
          <div className="skel" style={{ width:36, height:20, marginBottom:4 }}/>
          <div className="skel" style={{ width:24, height:8 }}/>
        </div>
      </div>
      <div className="skel" style={{ width:"100%", height:3, borderRadius:99 }}/>
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div style={{ padding:"28px 36px" }}>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -400px 0; }
          100% { background-position: 400px 0; }
        }
        .skel {
          background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
          background-size: 400px 100%;
          animation: shimmer 1.4s ease infinite;
          border-radius: 6px;
        }
      `}</style>
      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20 }}>
        <div>
          <div style={{ display:"flex", gap:12, alignItems:"center", marginBottom:8 }}>
            <div className="skel" style={{ width:36, height:36, borderRadius:8 }}/>
            <div className="skel" style={{ width:100, height:28 }}/>
            <div className="skel" style={{ width:70, height:22, borderRadius:20 }}/>
          </div>
          <div className="skel" style={{ width:180, height:12, marginBottom:6 }}/>
          <div className="skel" style={{ width:140, height:10 }}/>
        </div>
        <div className="skel" style={{ width:100, height:100, borderRadius:"50%" }}/>
      </div>
      {/* Info boxes */}
      <div style={{ display:"flex", gap:10, marginBottom:14 }}>
        <div className="skel" style={{ flex:1, height:52, borderRadius:10 }}/>
        <div className="skel" style={{ flex:2, height:52, borderRadius:10 }}/>
      </div>
      {/* Disclaimer */}
      <div className="skel" style={{ width:"100%", height:48, borderRadius:10, marginBottom:18 }}/>
      {/* Tabs */}
      <div style={{ display:"flex", gap:4, marginBottom:18 }}>
        <div className="skel" style={{ width:120, height:32, borderRadius:6 }}/>
        <div className="skel" style={{ width:120, height:32, borderRadius:6 }}/>
        <div className="skel" style={{ width:80, height:32, borderRadius:6 }}/>
      </div>
      {/* Ratio bars */}
      {[1,2,3,4,5].map(i => (
        <div key={i} className="skel" style={{ width:"100%", height:68, borderRadius:12, marginBottom:10 }}/>
      ))}
    </div>
  );
}
